module.exports = __webpack_public_path__ + "img/blimpy.5c4a4331.png";